import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import { LOCALE_PREFIX } from '../../constants'

import './style.scss'

export default class CreateNewGrpBtn extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        manageGroupsDialogCreateNewGroup: PropTypes.func.isRequired,
        settings: PropTypes.object,
        type: PropTypes.string.isRequired,
    }

    handleBtnClick = () => {
        const { settings, manageGroupsDialogCreateNewGroup, type, id } = this.props

        const entities = _.get(settings, 'entities', [])

        manageGroupsDialogCreateNewGroup(entities, { type, id })
        return null
    }

    render() {
        return (
            <div className={'manage-groups-dialog-create-new-grp-btn-container'}>
                <button className={'create-new-group-btn'} onClick={this.handleBtnClick}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.createNewGroup`} />
                </button>
            </div>
        )
    }
}
